<riv-modal *ngIf="_.hasBeenSummoned" (close)="_.closeModal()">
  <div [attr.data-animation-hook]="hook" class="side-sheet">
    <div class="side-sheet-header">
      <riv-icon [name]="'Sparkles'" slot="header-extras"></riv-icon>
      <h5>Rivet AI</h5>
      <div class="spacer"></div>
      <button
        rivButton
        [icon]="'X'"
        [variant]="'ghost'"
        [size]="'xsmall'"
        (click)="_.closeModal()"
        class="close-button"
      ></button>
    </div>
    <div class="chat-container">
      <div
        class="chat-header rv-flex"
        style="padding: var(--size-small)"
        id="threadsSelect"
      >
        <riv-select [manager]="_.threadsManager">
          <ng-template #trigger let-state="state">
            <button
              rivButton
              [icon]="'QueueList'"
              [variant]="'ghost'"
              [size]="'xsmall'"
              [disabled]="_.theRobotIsTalking"
            ></button>
          </ng-template>
          <ng-template #footer let-state="state">
            <button
              rivButton
              [size]="'small'"
              [variant]="'ghost'"
              [icon]="'Plus'"
              [full]="true"
              (click)="_.onNewThread()"
              [disabled]="_.isLimited"
            >
              Add new thread
            </button>
          </ng-template>
        </riv-select>
        <div *ngIf="_.editingThread" style="flex-grow: 1" id="threadTitleInput">
          <riv-text-field
            [value]="_.currentThread?.title || ''"
            (valueChange)="_.setTitle($event)"
            (keydown.enter)="_.touchThread(_.currentThread); _.onEditThread()"
            (blur)="_.touchThread(_.currentThread); _.onEditThread()"
          ></riv-text-field>
        </div>
        <h5
          class="rv-title-02"
          style="margin-left: var(--size-small)"
          *ngIf="!_.editingThread"
          (click)="_.onEditThread()"
        >
          {{ _.currentThread?.title ?? 'New thread' | truncate: 70 }}
        </h5>
        <div style="flex-grow: 1" *ngIf="!_.editingThread"></div>
        <button
          rivButton
          [icon]="'Check'"
          [variant]="'ghost'"
          [size]="'xsmall'"
          (click)="_.touchThread(_.currentThread); _.onEditThread()"
          *ngIf="_.editingThread"
        ></button>
        <button
          rivButton
          [icon]="'Plus'"
          [variant]="'ghost'"
          [size]="'xsmall'"
          (click)="_.onNewThread()"
          *ngIf="!_.editingThread"
          [disabled]="_.theRobotIsTalking || _.isLimited"
        ></button>
        <button
          rivButton
          [icon]="'Edit'"
          [variant]="'ghost'"
          [size]="'xsmall'"
          (click)="_.onEditThread()"
          *ngIf="!_.editingThread"
          [disabled]="_.theRobotIsTalking"
        ></button>
        <button
          rivButton
          [icon]="'Trash2'"
          [variant]="'ghost'"
          [size]="'xsmall'"
          (click)="_.onDeleteThread(_.currentThread)"
          *ngIf="!_.editingThread"
          [disabled]="
            _.theRobotIsTalking ||
            (_.threads.length === 1 && _.chatHistory.length === 0)
          "
        ></button>
      </div>
      <div class="chat-history">
        <div
          *ngFor="
            let message of _.chatHistory.slice().reverse();
            let i = index;
            trackBy: trackByIndex
          "
          class="chat-bubble-container"
          [ngClass]="{
            'user-message-container': message.source === RivvyMessageType.HUMAN
          }"
        >
          <div class="chat-meta">
            <span class="chat-username">{{
              message.source === RivvyMessageType.HUMAN ? 'You' : 'Rivet AI'
            }}</span>
            <span class="chat-timestamp">{{
              message.created | rivDate: 'short'
            }}</span>
          </div>
          <div
            class="chat-bubble"
            [ngClass]="{
              'user-message': message.source === RivvyMessageType.HUMAN,
              'assistant-message': message.source === RivvyMessageType.AI
            }"
          >
            <span
              *ngIf="!message.loading && message.source === RivvyMessageType.AI"
              class="rv-markdown"
              [innerHtml]="_.formatContent(message.content) | safeHtml"
            >
            </span>
            <span
              *ngIf="
                !message.loading && message.source === RivvyMessageType.HUMAN
              "
            >
              {{ message.content }}
            </span>
            <span
              *ngIf="
                message.loading ||
                (_.theRobotIsTalking &&
                  message.source === RivvyMessageType.AI &&
                  i === 0)
              "
            >
              <div class="chat-loading">
                <riv-loading [size]="16" [variant]="'dark'"></riv-loading>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div class="chat-bottom-wrapper" [class.ppa]="extensionExists()">
        <div class="mx-large my-large" *ngIf="_.isLimited">
          <riv-banner>
            Unfortunately, you have reached the limit of your Rivet AI usage.
            <button riv-banner-action (click)="openIntercom()">
              Contact support to increase your limit.
            </button>
          </riv-banner>
        </div>
        <div class="chat-input" *ngIf="!_.isLimited">
          <riv-textarea-field
            [value]="_.inputValue"
            (valueChange)="_.setInputValue($event)"
            (keydown.enter)="_.onSendMessage(_.currentThread)"
            [name]="'RivvyInput'"
            [size]="'large'"
            style="width: 100%"
            rows="2"
          ></riv-textarea-field>
        </div>
        <div class="chat-badges" *ngIf="!_.isLimited">
          <button
            rivButton
            [size]="'medium'"
            (click)="_.setShowSuggestions(true)"
            *ngIf="!_.showSuggestions"
          >
            Suggestions
          </button>
          <button
            rivButton
            [size]="'medium'"
            (click)="_.setShowSuggestions(false)"
            *ngIf="_.showSuggestions"
          >
            Close suggestions
          </button>
          <div class="spacer"></div>
          <div *ngIf="_.warn">
            <riv-banner>
              You are nearing the limit of your Rivet AI usage.
              <button riv-banner-action (click)="openIntercom()">
                Contact support to increase your limit.
              </button>
            </riv-banner>
          </div>
          <div class="spacer" *ngIf="_.warn"></div>
          <button
            rivButton
            [size]="'medium'"
            [icon]="'ArrowRight'"
            style="margin-right: var(--size-small)"
            (click)="_.onSendMessage(_.currentThread)"
            [loading]="_.theRobotIsTalking"
          ></button>
        </div>
        <div
          *ngIf="_.showSuggestions"
          class="suggestions"
          style="padding-right: var(--size-small)"
        >
          <button
            rivButton
            [size]="'medium'"
            [full]="true"
            [variant]="'ghost'"
            *ngFor="
              let suggestion of suggestions;
              let j = index;
              trackBy: trackByIndex
            "
            (click)="
              _.onSendMessage(_.currentThread, suggestion);
              _.setShowSuggestions(false)
            "
          >
            {{ suggestion }}
          </button>
        </div>
      </div>
      <div
        class="disclaimer"
        [class.ppa]="extensionExists()"
        *ngIf="helpfulDisclaimer && helpfulDisclaimer.length > 0"
      >
        <div style="flex-grow: 1">
          {{ helpfulDisclaimer }}
        </div>
      </div>
    </div>
  </div>
</riv-modal>
